import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { AuthProvider } from './providers/AuthProvider';
import RequireAuth from './RequireAuth.js';
import RequireRole from './providers/RequireRole';
// import Deathdetails from './ui-components/Deathdetails.js';
// import './axiosConfig';

const MasterLayout = lazy(() => import('./ui-components/MasterLayout'));
const Dashboard = lazy(() => import('./ui-components/Dashboard'));
const YearSettings = lazy(() => import('./ui-components/Year_settings'));
const ChangePassword = lazy(() => import('./ui-components/Change_password'));
const Parish = lazy(() => import('./ui-components/Parish'));
const AddParish = lazy(() => import('./ui-components/AddParish'));
const EditParish = lazy(() => import('./ui-components/EditParish'));
const Forane = lazy(() => import('./ui-components/Forane'));
const AddForane = lazy(() => import('./ui-components/AddForane'));
const EditForane = lazy(() => import('./ui-components/EditForane'));
const Congregation = lazy(() => import('./ui-components/Congregation'));
const Convent = lazy(() => import('./ui-components/Convent'));
const Mentor = lazy(() => import('./ui-components/Mentor'));
const OfficeStaff = lazy(() => import('./ui-components/OfficeStaff'));
const MentorProfile = lazy(() => import('./ui-components/MentorProfile'));
const MyStudents = lazy(() => import('./ui-components/MyStudents'));
const StudentDetails = lazy(() => import('./ui-components/StudentDetails'));
const CareerPath = lazy(() => import('./ui-components/CareerPath'));
const CourseManagement = lazy(() => import('./ui-components/CourseManagement'));
const EntryPathwayManagement = lazy(() => import('./ui-components/EntryPathwayManagement'));
const CareerLadderManagement = lazy(() => import('./ui-components/CareerLadderManagement'));
const StudentCareerAreas = lazy(() => import('./ui-components/student/StudentCareerAreas'));
const StudentCareerList = lazy(() => import('./ui-components/student/StudentCareerList'));
const StudentCareerDetails = lazy(() => import('./ui-components/student/StudentCareerDetails'));

const NewRegistration = lazy(() => import('./ui-components/NewRegistration'));
const Users = lazy(() => import('./ui-components/Users'));
const AptitudeCategory = lazy(() => import('./ui-components/AptitudeCategory'));
const AptitudeQuestion = lazy(() => import('./ui-components/AptitudeQuestion'));
const MentorStudentAssignment = lazy(() => import('./ui-components/MentorStudentAssignment'));
const MentorStudentList = lazy(() => import('./ui-components/MentorStudentList'));
const SundaySchool = lazy(() => import('./ui-components/SundaySchool'));
const AddSundaySchool = lazy(() => import('./ui-components/AddSundaySchool'));
const EditSundaySchool = lazy(() => import('./ui-components/EditSundaySchool'));

const EducationLevel = lazy(() => import('./ui-components/EducationLevel'));
const EducationStream = lazy(() => import('./ui-components/EducationStream'));
const EducationCourse = lazy(() => import('./ui-components/EducationCourse'));
const EcosIntegration = lazy(() => import('./ui-components/EcosIntegration'));
const ImportedStudentsList = lazy(() => import('./ui-components/ImportedStudentsList'));
const StudentRegistration = lazy(() => import('./ui-components/StudentRegistration'));
const StudentProfile = lazy(() => import('./ui-components/StudentProfile'));
const CareerArea = lazy(() => import('./ui-components/CareerArea'));
const StudentBasicInfo = lazy(() => import('./ui-components/StudentBasicInfo'));

const Careers = lazy(() => import('./ui-components/Careers'));
const CareerTypes = lazy(() => import('./ui-components/CareerTypes'));
const CareerDetails = lazy(() => import('./ui-components/CareerDetails'));
const InstitutionManagement = lazy(() => import('./ui-components/InstitutionManagement'));
const CareerCourseManagement = lazy(() => import('./ui-components/CareerCourseManagement'));
const CourseInstitutionManagement = lazy(() => import('./ui-components/CourseInstitutionManagement'));
const TakeAptitudeTest = lazy(() => import('./ui-components/TakeAptitudeTest'));
const TakePersonalityTest = lazy(() => import('./ui-components/TakePersonalityTest'));
const AptitudeAssessment = lazy(() => import('./ui-components/AptitudeAssessment'));
const MentorAptitudeDashboard = lazy(() => import('./ui-components/MentorAptitudeDashboard'));
const ReviewAptitudeTest = lazy(() => import('./ui-components/ReviewAptitudeTest'));
const PersonalityCategory = lazy(() => import('./ui-components/PersonalityCategory'));
const PersonalityQuestion = lazy(() => import('./ui-components/PersonalityQuestion'));

const Login = lazy(() => import('./Login'));

const ResetPassword = lazy(() => import('./ResetPassword'));
const ForgotPassword = lazy(() => import('./ForgotPassword'));
const UpdatePassword = lazy(() => import('./UpdatePassword'));
const StudentProfile_data = lazy(() => import('./ui-components/StudentProfile_data'));
const Reports = lazy(() => import('./ui-components/Reports'));
const CareerAreaNews = lazy(() => import('./ui-components/CareerAreaNews'));
const OTPLogin = lazy(() => import('./OTPLogin'));
const StudentQuestionnaireView = lazy(() => import('./ui-components/StudentQuestionnaireView'));
const CreateStudent = lazy(() => import('./ui-components/CreateStudent'));
const PerformanceCategory = lazy(() => import('./ui-components/PerformanceCategory'));
const StudentCounseling = lazy(() => import('./ui-components/student/StudentCounseling'));
const StudentAcademicMenu = lazy(() => import('./ui-components/student/StudentAcademicMenu'));
const StudentPerformanceList = lazy(() => import('./ui-components/StudentPerformanceList'));
function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/update-password" element={<UpdatePassword />} />

        </Routes>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/otp-login" element={<OTPLogin />} />
            <Route path="/" element={<RequireAuth><MasterLayout /></RequireAuth>}>

              <Route index element={<Dashboard />} />

              <Route path="year_setting" element={
                <RequireRole allowedRoles={['admin', 'office_staff', 'mentor']}>
                  <YearSettings />
                </RequireRole>
              } />

              <Route path="change_password" element={
                <RequireRole allowedRoles={['admin', 'forane', 'zone', 'country', 'member', 'office', 'global', 'parish', 'office_staff', 'mentor', 'student']}>
                  <ChangePassword />
                </RequireRole>
              } />

              <Route path="parish"
                element={<RequireRole allowedRoles={['admin', 'office_staff', 'mentor']}>
                  <Parish />
                </RequireRole>
                } />

              <Route path="parish/add" element={<RequireRole allowedRoles={['admin']}>
                <AddParish />
              </RequireRole>
              } />

              <Route path="parish/edit/:id" element={<RequireRole allowedRoles={['admin']}>
                <EditParish />
              </RequireRole>
              } />

              <Route path="forane" element={<RequireRole allowedRoles={['admin', 'office_staff', 'mentor']}>
                <Forane />
              </RequireRole>
              } />

              <Route path="forane/add" element={<RequireRole allowedRoles={['admin']}>
                <AddForane />
              </RequireRole>
              } />

              <Route path="forane/edit/:id" element={<RequireRole allowedRoles={['admin']}>
                <EditForane />
              </RequireRole>
              } />

              <Route path="congregation" element={<RequireRole allowedRoles={['admin', 'office_staff', 'mentor']}>
                <Congregation />
              </RequireRole>
              } />

              <Route path="convent" element={<RequireRole allowedRoles={['admin', 'office_staff', 'mentor']}>
                <Convent />
              </RequireRole>
              } />

              <Route path="mentor" element={<RequireRole allowedRoles={['admin', 'office_staff', 'mentor']}>
                <Mentor />
              </RequireRole>
              } />

              <Route path="office_staff" element={<RequireRole allowedRoles={['admin', 'office_staff', 'mentor']}>
                <OfficeStaff />
              </RequireRole>
              } />

              <Route path="mentor_profile" element={<RequireRole allowedRoles={['mentor', 'admin', 'office_staff']}>
                <MentorProfile />
              </RequireRole>
              } />

              <Route path="my_students" element={<RequireRole allowedRoles={['mentor', 'admin', 'office_staff']}>
                <MyStudents />
              </RequireRole>
              } />

              <Route path="student_details" element={<RequireRole allowedRoles={['mentor', 'admin', 'office_staff']}>
                <StudentDetails />
              </RequireRole>
              } />

              <Route path="mentor-aptitude" element={<RequireRole allowedRoles={['mentor', 'admin', 'office_staff']}>
                <MentorAptitudeDashboard />
              </RequireRole>
              } />

              <Route path="take-test/:studentId" element={<RequireRole allowedRoles={['mentor', 'student', 'admin', 'office_staff']}>
                <TakeAptitudeTest />
              </RequireRole>
              } />

              <Route path="take-personality-test/:studentId" element={<RequireRole allowedRoles={['mentor', 'student', 'admin', 'office_staff']}>
                <TakePersonalityTest />
              </RequireRole>
              } />

              <Route path="review-test/:attemptId" element={<RequireRole allowedRoles={['mentor', 'student', 'admin', 'office_staff']}>
                <ReviewAptitudeTest />
              </RequireRole>
              } />


              <Route path="sundayschool" element={<RequireRole allowedRoles={['admin']}>
                <SundaySchool />
              </RequireRole>
              } />

              <Route path="sundayschool/add" element={<RequireRole allowedRoles={['admin']}>
                <AddSundaySchool />
              </RequireRole>
              } />

              <Route path="sundayschool/edit/:id" element={<RequireRole allowedRoles={['admin']}>
                <EditSundaySchool />
              </RequireRole>
              } />

              <Route path="education-level" element={<RequireRole allowedRoles={['admin']}>
                <EducationLevel />
              </RequireRole>
              } />

              <Route path="education-stream" element={<RequireRole allowedRoles={['admin']}>
                <EducationStream />
              </RequireRole>
              } />

              <Route path="education-course" element={<RequireRole allowedRoles={['admin']}>
                <EducationCourse />
              </RequireRole>
              } />

              <Route path="ecos-integration" element={<RequireRole allowedRoles={['admin']}>
                <EcosIntegration />
              </RequireRole>
              } />

              <Route path="imported-students" element={<RequireRole allowedRoles={['admin']}>
                <ImportedStudentsList />
              </RequireRole>
              } />

              <Route path="student-registration" element={<RequireRole allowedRoles={['admin']}>
                <StudentRegistration />
              </RequireRole>
              } />


              <Route path="student_profile" element={<RequireRole allowedRoles={['student', 'admin', 'office_staff']}>
                <StudentProfile />
              </RequireRole>} />

              <Route path="career-area" element={<RequireRole allowedRoles={['admin']}>
                <CareerArea />
              </RequireRole>
              } />

              <Route path="career_path" element={<RequireRole allowedRoles={['student', 'admin']}>
                <CareerPath />
              </RequireRole>
              } />


              <Route path="aptitude_assessment" element={<RequireRole allowedRoles={['student', 'admin']}>
                <AptitudeAssessment />
              </RequireRole>
              } />

              <Route path="student/career-areas" element={<RequireRole allowedRoles={['student', 'mentor', 'admin', 'office_staff']}>
                <StudentCareerAreas />
              </RequireRole>} />

              <Route path="student/career-list/:id" element={<RequireRole allowedRoles={['student', 'mentor', 'admin', 'office_staff']}>
                <StudentCareerList />
              </RequireRole>} />

              <Route path="student/career-details/:id" element={<RequireRole allowedRoles={['student', 'mentor', 'admin', 'office_staff']}>
                <StudentCareerDetails />
              </RequireRole>} />

              <Route path="newregistration" element={<RequireRole allowedRoles={['zone', 'parish', 'admin', 'office', 'office_staff', 'mentor']}>
                <NewRegistration />
              </RequireRole>
              } />

              <Route path="users" element={
                <RequireRole allowedRoles={['parish']}>
                  <Users />
                </RequireRole>
              } />

              <Route path="reports" element={
                <RequireRole allowedRoles={['admin', 'mentor']}>
                  <Reports />
                </RequireRole>
              } />

              <Route path="aptitude-management" element={<RequireRole allowedRoles={['admin']}>
                <AptitudeCategory />
              </RequireRole>
              } />

              <Route path="aptitude-management/questions/:categoryId" element={<RequireRole allowedRoles={['admin', 'mentor']}>
                <AptitudeQuestion />
              </RequireRole>
              } />

              <Route path="personality-management" element={<RequireRole allowedRoles={['admin']}>
                <PersonalityCategory />
              </RequireRole>
              } />

              <Route path="personality-management/questions/:categoryId" element={<RequireRole allowedRoles={['admin', 'mentor']}>
                <PersonalityQuestion />
              </RequireRole>
              } />

              <Route path="aptitude_question_bank" element={<RequireRole allowedRoles={['admin', 'mentor']}>
                <AptitudeQuestion />
              </RequireRole>
              } />

              <Route path="personality_question_bank" element={<RequireRole allowedRoles={['admin', 'mentor']}>
                <PersonalityQuestion />
              </RequireRole>
              } />

              <Route path="mentor-student-assignment" element={<RequireRole allowedRoles={['admin']}>
                <MentorStudentAssignment />
              </RequireRole>
              } />

              <Route path="mentor-student-list" element={<RequireRole allowedRoles={['admin']}>
                <MentorStudentList />
              </RequireRole>
              } />
              <Route path="mentor-student-list/:mentorId" element={<RequireRole allowedRoles={['admin']}>
                <MentorStudentList />
              </RequireRole>
              } />

              <Route path="careers" element={<RequireRole allowedRoles={['admin']}>
                <Careers />
              </RequireRole>
              } />

              <Route path="career-types" element={<RequireRole allowedRoles={['admin']}>
                <CareerTypes />
              </RequireRole>
              } />

              <Route path="career-details/:id" element={<RequireRole allowedRoles={['admin']}>
                <CareerDetails />
              </RequireRole>
              } />

              <Route path="courses" element={<RequireRole allowedRoles={['admin', 'office_staff']}>
                <CourseManagement />
              </RequireRole>
              } />

              <Route path="institutions" element={<RequireRole allowedRoles={['admin', 'office_staff']}>
                <InstitutionManagement />
              </RequireRole>
              } />

              <Route path="career-courses" element={<RequireRole allowedRoles={['admin', 'office_staff']}>
                <CareerCourseManagement />
              </RequireRole>
              } />

              <Route path="course-institutions" element={<RequireRole allowedRoles={['admin', 'office_staff']}>
                <CourseInstitutionManagement />
              </RequireRole>
              } />

              <Route path="entry-pathways" element={<RequireRole allowedRoles={['admin']}>
                <EntryPathwayManagement />
              </RequireRole>
              } />

              <Route path="career-ladders" element={<RequireRole allowedRoles={['admin']}>
                <CareerLadderManagement />
              </RequireRole>
              } />

              <Route path="sundayschool" element={<RequireRole allowedRoles={['admin']}>
                <SundaySchool />
              </RequireRole>
              } />
              <Route path="student-profile-data/:id" element={<RequireRole allowedRoles={['admin']}>
                <StudentProfile_data />
              </RequireRole>
              } />

              <Route path="career-area-news" element={<RequireRole allowedRoles={['admin', 'mentor', 'office_staff']}>
                <CareerAreaNews />
              </RequireRole>
              } />
              <Route path="student-profile/:id" element={<RequireRole allowedRoles={['admin', 'mentor', 'office_staff']}>
                <StudentProfile />
              </RequireRole>} />
              <Route path="performance-category" element={<RequireRole allowedRoles={['admin']}>
                <PerformanceCategory />
              </RequireRole>
              } />

              <Route path="student-basic-info/:id" element={<RequireRole allowedRoles={['admin', 'office_staff', 'mentor']}>
                <StudentBasicInfo />
              </RequireRole>} />
              <Route path="create-student" element={<RequireRole allowedRoles={['admin']}>
                <CreateStudent />
              </RequireRole>
              } />

              {/* Student Specific Routes */}
              <Route path="student/questionnaire" element={<RequireRole allowedRoles={['student']}>
                <StudentQuestionnaireView />
              </RequireRole>} />

              <Route path="student/counseling" element={<RequireRole allowedRoles={['student']}>
                <StudentCounseling />
              </RequireRole>} />

              <Route path="student/academic" element={<RequireRole allowedRoles={['student']}>
                <StudentAcademicMenu />
              </RequireRole>} />

              <Route path="student-performance" element={<RequireRole allowedRoles={['admin', 'mentor', 'office_staff']}>
                <StudentPerformanceList />
              </RequireRole>} />
            </Route>

          </Routes>
        </AuthProvider>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
